import { route } from 'quasar/wrappers';
import {
  createRouter, createMemoryHistory, createWebHistory, createWebHashHistory,
} from 'vue-router';
import multiguard from '@router/routerMultiguard';
import { unsavedRouteGuard } from '@router/guards/unsavedProtectionGuard';
import { pagesGuard } from '@router/guards/pagesGuard';
import { formatMetaTitle } from '@utils/useMetaTitle';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route((/* { store } */) => {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach(multiguard([
    unsavedRouteGuard,
    pagesGuard,
  ]));

  // Dynamic page titles
  Router.afterEach(async (to) => {
    if (to?.meta?.title) {
      document.title = formatMetaTitle(to?.meta?.title);
    }
  });

  return Router;
});
